import { mapActions } from "vuex";

export default {
  methods: {
    ...mapActions("doctor", ["updateDoctorActive", "deleteDoctor"]),
  },
};
